import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import Ionic from '@ionic/vue'
import VueSlider from 'vue-slider-component'
import { VueAgile } from 'vue-agile'
import store from './store'
// import axios from 'axios'
import Geocoder from '@pderas/vue2-geocoder'
import VueDaumMap from 'vue-daum-map'
import infiniteScroll from 'vue-infinite-scroll'
import VueScrollactive from 'vue-scrollactive'
import vmodal from 'vue-js-modal'
import PrettyCheckbox from 'pretty-checkbox-vue'

// import '@ionic/core/css/ionic.bundle.css'
import '@mdi/font/css/materialdesignicons.min.css'
import 'reset-css/reset.css'
import './assets/css/global.less'
import 'vue-slider-component/theme/default.css'
import 'pretty-checkbox/dist/pretty-checkbox.css'
import './assets/css/new-style.css' // 백대선 추가.

import axiosInstance from './core/modules/axiosInstance'
import VueMq from 'vue-mq'
import config from './config'
import vueHeadful from 'vue-headful'


Vue.use(PrettyCheckbox)

Vue.use(Geocoder, {
  defaultCountryCode: 'kr', // e.g. 'CA'
  defaultLanguage:    'ko', // e.g. 'en'
  defaultMode:        'address', // or 'lat-lng'
  googleMapsApiKey:   config.API_KEY.GOOGLE_MAPS
})

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 769,
    md: 1367,
    lg: Infinity,
  }
})

Vue.use(VueScrollactive)
Vue.use(infiniteScroll)
Vue.use(VueDaumMap)
Vue.use(vmodal, {
  dynamic: true,
})

Vue.component('vue-headful', vueHeadful)

Vue.component('VueSlider', VueSlider)
// Vue.use(Ionic)
Vue.use(VueAgile)
Vue.config.productionTip = false

Vue.prototype.axios = axiosInstance
Vue.prototype.daum = window.daum


function isNativeApp () {
  if (navigator.userAgent.indexOf('KosirockApp') > -1) {
    return true
  }
  return false
}


if (isNativeApp()) {
  store.dispatch('setIsNative', true)
} else {
  store.dispatch('setIsNative', false)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
